import { cn } from 'cn';
import * as React from 'react';

import { PageContainer } from './page-container';

/** RIA's non-linear scale maps its three financial-advisor section rhythms. */
const SPACING = {
  default: 'py-14',
  compact: 'py-4',
  bottom: 'pb-14',
} as const;

/** Semantic surfaces from Theme/index.ts:380. */
const BACKGROUNDS = {
  muted: 'bg-muted',
  paper: 'bg-background',
} as const;

type SectionProps = Omit<React.ComponentProps<'section'>, 'children'> & {
  'aria-label': string;
  spacing?: keyof typeof SPACING;
  bg?: keyof typeof BACKGROUNDS;
  bordered?: boolean;
  width?: React.ComponentProps<typeof PageContainer>['width'];
  children: React.ReactNode;
};

/**
 * A labelled page section wrapping a page container.
 *
 * `px-4` on the section plus PageContainer gutters matches
 * `SectionContainer.tsx` (`sx.px: 3` + MUI `Container`).
 */
function Section({
  spacing = 'default',
  bg = 'muted',
  bordered = false,
  width,
  className,
  children,
  ...props
}: SectionProps) {
  return (
    <section
      data-slot="section"
      className={cn(
        'px-4',
        SPACING[spacing],
        BACKGROUNDS[bg],
        bordered && 'border-y border-border',
        className,
      )}
      {...props}
    >
      <PageContainer width={width}>{children}</PageContainer>
    </section>
  );
}

export { Section };
